import { Reveal, Eyebrow } from './Reveal';

const STEPS = [
  {
    n: '01',
    title: 'Business Mapping',
    body: 'We pinpoint your target local customers, high-margin services and the administrative bottlenecks worth automating first.',
  },
  {
    n: '02',
    title: 'Custom Build & Automation',
    body: 'We engineer your fast mobile frontend, interactive quote tools and direct CRM / booking automations — 100% custom code.',
  },
  {
    n: '03',
    title: 'Edge Launch & Handover',
    body: 'Enterprise-grade deployment on AWS and Cloudflare edge networks: 99.99% uptime, automated SSL, zero maintenance headaches.',
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <Eyebrow>How We Work</Eyebrow>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
            The GSLAB <span className="text-gradient-gold">turnkey process.</span>
          </h2>
          <p className="mt-4 text-slate-400 max-w-xl text-base">A smooth, stress-free build that lets you focus on running your business.</p>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-10 relative">
          <div className="hidden md:block absolute top-7 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />
          {STEPS.map((s, i) => (
            <Reveal key={s.n} i={i + 1}>
              <div className="relative">
                <div className="h-14 w-14 rounded-full border border-amber-500/40 bg-[#0F1C33] flex items-center justify-center font-mono-tech text-amber-300 font-semibold mb-6 relative z-10">
                  {s.n}
                </div>
                <h3 className="font-display font-semibold text-xl mb-3">{s.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
